import instance from "../components/general/AxiosInterceptor";
const controller = "/api/notifications";

export const loadNotifications = async (page, size) => {
  console.log("loadNotifications");
  const response = await instance.get(`${controller}?page=${page}&size=${size}`); 
  return response.data?.body;
};

export const readNotificationApi = async (id) => {
  const response = await instance.post(`${controller}/read/${id}`, {});
  return response.data;
};

export const readAllNotificationApi = async () => {
  const response = await instance.post(`${controller}/read-all`, {});
  return response.data;
};